import { Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { SecondContainer } from "./styles";
import { ProviderSiteAdvertisementPopupSummaryDTO } from "../../../../models/provider-site-advertisement-popup-summary/provider-site-advertisement-popup-summary-dto";

const OpenProviderPopupsLink = ({
  customSummary,
  loading,
}: {
  customSummary: ProviderSiteAdvertisementPopupSummaryDTO;
  loading: boolean;
}) => {
  const tRP = "components.custom_widget_links.help_and_tips.ran_out_of_popups";
  const { t } = useTranslation();
  return (
    <>
      <SecondContainer>
        <Typography>{`${t(`${tRP}`)}`}</Typography>
        <Typography variant="h4">
          <b>{customSummary.ranOutOfPopup ?? 0}</b>
        </Typography>
      </SecondContainer>
    </>
  );
};

export default OpenProviderPopupsLink;
